export default __webpack_public_path__ + "static/media/gallery_01.15a96a4e.jpg";